import React, { useCallback, useMemo } from 'react';
import { Box, Toggle, Flex, TextV2 } from '@withjoy/joykit';
import { useCreditCardSetupContext } from '@apps/registry/admin/components/CreditCardSetup/CreditCardSetUp.context';
import { KYCStatus } from './components/KYCStatus';
import { useSharedRegistryTranslations } from '@apps/registry/SharedRegistry.i18n';
import { FormikProps } from 'formik';
import { AddCashFundDialogFields } from '../../../../types';
import { useHistory } from '@shared/core';
import { useLocation } from '@react-router';
import { useCreditCardSetupTelemetry } from '@apps/registry/admin/components/CreditCardSetup/CreditCardSetUp.telemetry';
import { styles } from '../../CashFundPaymentMethod.style';

interface CreditCardToggleProps {
  formik: FormikProps<AddCashFundDialogFields>;
}

export const CreditCardToggle: React.FC<CreditCardToggleProps> = props => {
  const location = useLocation();
  const history = useHistory();
  const telemetry = useCreditCardSetupTelemetry();
  const { getCashFundDialogTranslations } = useSharedRegistryTranslations();
  const { usOnly, creditCardOption, creditCardOptionDescription } = getCashFundDialogTranslations();
  const { payoutAccountInfo, fetchingPayoutInfo } = useCreditCardSetupContext();
  const setUpCreditCardLocation = useMemo(() => (location.search ? `${location.pathname}${location.search}&setupCreditCard=true` : `${location.pathname}?setupCreditCard=true`), [
    location
  ]);

  const onToggleChange = useCallback(
    e => {
      if (payoutAccountInfo && !fetchingPayoutInfo && payoutAccountInfo.status === 'readyToUse') {
        return props.formik.handleChange(e);
      }
      telemetry.toggleCreditCardOption();
      return history.push(setUpCreditCardLocation);
    },
    [payoutAccountInfo, fetchingPayoutInfo, history, setUpCreditCardLocation, props.formik, telemetry]
  );

  if (payoutAccountInfo && !fetchingPayoutInfo && payoutAccountInfo.status === 'pending')
    return (
      <Box marginTop={5} marginBottom={5}>
        <KYCStatus />
      </Box>
    );

  return (
    <Box marginTop={5} marginBottom={5}>
      <Flex __css={styles.toggleWrapper({ isChecked: props.formik.values.enableJoyCredit })}>
        <Box>
          <Flex alignItems="center">
            <TextV2 typographyVariant="hed1" marginRight={2}>
              {creditCardOption}
            </TextV2>
            <TextV2 typographyVariant="label2" color="mono12">
              {usOnly}
            </TextV2>
          </Flex>
          <TextV2 typographyVariant="label2" color="mono12">
            {creditCardOptionDescription}
          </TextV2>
        </Box>
        <Flex justifyContent="center">
          <Toggle label="" intent="neutral" hideLabel={true} checked={props.formik.values.enableJoyCredit} name="enableJoyCredit" onChange={onToggleChange} />
        </Flex>
      </Flex>
    </Box>
  );
};
